var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#5A189A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C15.45 32 14.9793 31.8043 14.588 31.413C14.1967 31.0217 14.0007 30.5507 14 30V18C14 17.45 14.196 16.9793 14.588 16.588C14.98 16.1967 15.4507 16.0007 16 16H32C32.55 16 33.021 16.196 33.413 16.588C33.805 16.98 34.0007 17.4507 34 18V30C34 30.55 33.8043 31.021 33.413 31.413C33.0217 31.805 32.5507 32.0007 32 32H16ZM24 25L32 20V18L24 23L16 18V20L24 25Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSymbol);
export default __webpack_public_path__ + "static/media/mail-symbol.c2c780d458256628da98958bf0a0cf3f.svg";
export { ForwardRef as ReactComponent };